export default {
  endDate(value, previousValue, allValues) {
    if (/^[ \/\.]+$/.test(value)) {
      return ''
    }
    return value
  },
}
